import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SellerLabel, colorPalette } from '@next-common/mui';
import StoreIcon from '@mui/icons-material/Store';
import { IconWrapper } from './Seller.style';
export const SellerBio = ({ seller }) => {
    var _a, _b;
    return (React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 },
        (seller === null || seller === void 0 ? void 0 : seller.eshopLogoUrl) ? (React.createElement(Box, { component: "img", sx: {
                border: `1px solid ${colorPalette.gray200}`,
                borderRadius: '4px',
            }, src: seller === null || seller === void 0 ? void 0 : seller.eshopLogoUrl, width: 30, height: 30, alt: "eshop logo" })) : (React.createElement(IconWrapper, null,
            React.createElement(StoreIcon, { sx: {
                    width: '16px',
                    height: '16px',
                    color: colorPalette.gray700,
                } }))),
        React.createElement(Typography, { sx: {
                fontSize: '14px',
                fontWeight: 600,
                color: colorPalette.gray900,
            } }, seller === null || seller === void 0 ? void 0 : seller.eshopName),
        React.createElement(SellerLabel, { label: (seller === null || seller === void 0 ? void 0 : seller.isPro) ? 'Pro' : (seller === null || seller === void 0 ? void 0 : seller.isCrew) ? 'Site partenaire' : 'Particulier', isFrench: ((_b = (_a = seller === null || seller === void 0 ? void 0 : seller.legalNotice) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.countryName) === 'France' })));
};
